import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Tags from "../elements/Tags"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". event-3 event-3 event-3" "culture-1 culture-1 . ." ". . culture-2 culture-2";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
  }
  .event-4 {
    grid-area: event-4;
  }
  .culture-1 {
    grid-area: culture-1;
    align-self: center;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" "event-3 event-3 event-2 event-2" "event-3 event-3 culture-1 ." ". culture-2 culture-1 ." ". culture-2 . .";
  }
  @media (min-width: 1200px) {
  }
`

const February = () => {
  const data = useStaticQuery(graphql`
    query {
      febEventOne: file(relativePath: { eq: "events/february/event-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      febEventTwo: file(relativePath: { eq: "events/february/event-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      febEventThree: file(relativePath: { eq: "events/february/event-3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      febCultureOne: file(
        relativePath: { eq: "events/february/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 700, maxHeight: 702, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      febCultureTwo: file(
        relativePath: { eq: "events/february/culture-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="february">
      <Grid>
        <Block className="event-1">
          <Photo img={data.febEventOne} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            Banks suck. That’s why we’re helping a new kid on the block change
            the game.
          </h4>
        </Block>
        <Block className="event-2">
          <Photo img={data.febEventTwo} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            <a
              href="https://bettr.finance/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Bettr
            </a>{" "}
            makes saving and investing super easy.
          </h4>
          <Tags
            maxWidth={800}
            words={[
              "react",
              "reactnative",
              "graphql",
              "serverless",
              "nodejs",
              "postgresql",
            ]}
          />
        </Block>
        <Block className="event-3">
          <Photo img={data.febEventThree} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            And to find out your spending trends and stats, you simply talk to
            the app.
          </h4>
        </Block>
        <Block className="culture-1">
          <Photo img={data.febCultureOne} maxWidth={700} maxHeight={702} />
          <h4 style={{ maxWidth: 700 }}>
            Also, Bevan, one of our tech leads, hooked up a{" "}
            <a
              href="https://rookcycles.com"
              target="_blank"
              rel="noreferrer noopener"
              className="mouse-link"
            >
              Rook
            </a>{" "}
            🚴‍
          </h4>
        </Block>
        <Block className="culture-2">
          <Photo img={data.febCultureTwo} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>
            Ilian, our Chief Architect, got one year older.
          </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default February
